export const valueSetEvent = (name: string) => `${name}_VALUE_SET`;
